const getAvailableBriefDatesResponse = (response) => {
  return response?.data?.calendarStatuses || [];
};

export default getAvailableBriefDatesResponse;
